<div class="mainstepcontent row w100">
  <div class="leftside col">
    <div class="col gap-16">
      <div class="col">
        <div class="stepcounter">
          STEP {{ thisStepCount }}/{{ totalStepCount }}
        </div>
        <h1>{{ step.stepTypeName }}</h1>
      </div>
      <div
        class="instructions align-center row gap-8 pointer"
        (click)="openInstructions()"
      >
        <div class="secondary-text">
          Johnny suggests potential users. Swipe to accept or reject, or use the
          green/red buttons. Unsure? Tap ‘Skip’. Focus on your
          <b>early adopters!</b>
        </div>
        <div class="instructions align-center row gap-8 pointer">
          <rr-icon name="info"></rr-icon>
          <div class="underline">Instructions</div>
        </div>
      </div>
      <div class="results col gap-8 w100">
        <div class="row space-between w100">
          <div class="results-heading">My Users</div>
          <div class="results-skipped" (click)="showSkipped()">
            Show Skipped
          </div>
        </div>
        <div class="row gap-16 results-container w100">
          <div class="results-icon">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
            >
              <path
                d="M13.3333 23.332C13.3333 23.332 15.8333 26.6654 19.9999 26.6654C24.1666 26.6654 26.6666 23.332 26.6666 23.332M14.9999 14.9987H15.0166M24.9999 14.9987H25.0166M36.6666 19.9987C36.6666 29.2034 29.2047 36.6654 19.9999 36.6654C10.7952 36.6654 3.33325 29.2034 3.33325 19.9987C3.33325 10.794 10.7952 3.33203 19.9999 3.33203C29.2047 3.33203 36.6666 10.794 36.6666 19.9987Z"
                stroke="#067A57"
                stroke-opacity="0.8"
                stroke-width="3.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            class="results-item"
            *ngFor="let item of positivePersonas"
            (click)="removeSelection(item)"
          >
            <div
              class="result-image"
              [style.background]="
                item.image ? item.image : 'url(images/default-persona.png)'
              "
            ></div>
            <div class="result-label">{{ item.name }}</div>
          </div>
        </div>
        <div class="row gap-16 results-container w100">
          <div class="results-icon">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.3333 24.9987H26.6666M14.9999 14.9987H15.0166M24.9999 14.9987H25.0166M36.6666 19.9987C36.6666 29.2034 29.2047 36.6654 19.9999 36.6654C10.7952 36.6654 3.33325 29.2034 3.33325 19.9987C3.33325 10.794 10.7952 3.33203 19.9999 3.33203C29.2047 3.33203 36.6666 10.794 36.6666 19.9987Z"
                stroke="#C73A3A"
                stroke-opacity="0.8"
                stroke-width="3.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            class="results-item"
            *ngFor="let item of negativePersonas"
            (click)="removeSelection(item)"
          >
            <div
              class="result-image"
              [style.background]="
                item.image ? item.image : 'url(images/default-persona.png)'
              "
            ></div>
            <div class="result-label">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="rightside">
    <div class="tinder" *ngIf="personaQueue.length >= 1">
      <div class="persona">
        <div class="persona-inner">
          <div class="icon-and-text">
            <div class="top-label">Potential User</div>
            <div class="col gap-16">
              <div class="header">
                {{ personaQueue[0].name }}
              </div>
              <div
                class="image"
                [style.background]="
                  personaQueue[0].image
                    ? personaQueue[0].image
                    : 'url(images/default-persona.png)'
                "
              ></div>
              <div class="description">
                {{ personaQueue[0].description }}
              </div>
            </div>
          </div>
          <div class="tag-group">
            <rr-badge *ngFor="let tag of personaQueue[0].tags">{{
              tag.name
            }}</rr-badge>
          </div>
          <div class="action w100">
            <rr-btn type="Secondary" tone="brand" iconEnd="arrow-down"
              >Show full persona</rr-btn
            >
          </div>
        </div>
        <div class="tinder-btn no-match" (click)="noMatchPersona()">
          <div class="tinder-btn-inner">
            <svg
              width="87"
              height="87"
              viewBox="0 0 87 87"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 54.375H58M32.625 32.625H32.6613M54.375 32.625H54.4113M79.75 43.5C79.75 63.5203 63.5203 79.75 43.5 79.75C23.4797 79.75 7.25 63.5203 7.25 43.5C7.25 23.4797 23.4797 7.25 43.5 7.25C63.5203 7.25 79.75 23.4797 79.75 43.5Z"
                stroke="#C73A3A"
                stroke-opacity="0.8"
                stroke-width="7.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="tinder-btn match" (click)="matchPersona()">
          <div class="tinder-btn-inner">
            <svg
              width="87"
              height="87"
              viewBox="0 0 87 87"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 50.75C29 50.75 34.4375 58 43.5 58C52.5625 58 58 50.75 58 50.75M32.625 32.625H32.6613M54.375 32.625H54.4113M79.75 43.5C79.75 63.5203 63.5203 79.75 43.5 79.75C23.4797 79.75 7.25 63.5203 7.25 43.5C7.25 23.4797 23.4797 7.25 43.5 7.25C63.5203 7.25 79.75 23.4797 79.75 43.5Z"
                stroke="#067A57"
                stroke-opacity="0.8"
                stroke-width="7.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <rr-btn type="Secondary" tone="brand" (btnclick)="skipPersona()"
        >Skip</rr-btn
      >
    </div>
    <div *ngIf="personaQueue.length < 1">
      <div class="tinder">
        <div class="persona">
          <div class="queueEnd">
            <div>There are no users left.</div>
            <rr-btn type="Primary" tone="brand" iconStart="ai"
              >Generate more</rr-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer row align-center">
  <div class="leftside row gap-16 align-center">
    <rr-btn
      type="Primary"
      [disabled]="nextBtnDisabledStatus"
      (click)="nextStep()"
      >Next Step</rr-btn
    >
    <rr-btn type="Link" iconStart="arrow-left" size="medium">Back</rr-btn>
  </div>
  <div class="middle row grow-1 align-center justify-center">
    <div class="inner align-center row">
      <div class="stepcounter">
        STEP {{ thisStepCount }}/{{ totalStepCount }}
      </div>
      <rr-progress [progress]="progress"></rr-progress>
    </div>
  </div>
  <div class="rightside row gap-16 align-center">
    <rr-btn type="Secondary" size="Small" iconStart="upload"
      >Upload Knowledge</rr-btn
    >
    <rr-btn
      type="Secondary"
      size="Small"
      iconStart="add"
      (btnClick)="skipPersona()"
      >Show Result</rr-btn
    >
  </div>
</div>
